import http from '~/common/http'

export const Model = {
    id: "",
    customer_id: "",
    customer_name: '',
    name: "",
    type: "",
    status: "",
    job: "",
    mobile: "",
    qq: "",
    memo: "",
    products: [],
    province_id: 0,
    city_id: 0,
    district_id: 0
};

const TYPE_CONTACTS = 1; //联系人
const TYPE_LEADER = 2; //负责人
const TYPE_OTHER = 3; //其他


const STATUS_NOSTATE = 0; //否
const STATUS_RTURNVISIT =1; //是

const JOB_RECTOR = 1; //校长
const JOB_DIRECTOR = 2; //主任
const JOB_TEACHER = 3; //教师
const JOB_OTHER = 4; //其他


export default {

    // 得到联系人模型实例
    getModel() {
        return {
            id: "",
            customer_id: "",
            customer_name: '',
            name: "",
            type: "",
            status: "",
            job: "",
            mobile: "",
            qq: "",
            memo: "",
            phone_number:"",
            products: [],
            province_id: 0,
            city_id: 0,
            district_id: 0,
            parent_id: '',
        };
    },

    //得到联系人类型枚举
    getTypes() {
        return {
            [TYPE_CONTACTS]: '申请人',
            [TYPE_LEADER]: '负责人',
            [TYPE_OTHER]: '其他'
        }
    },

    //得到联系人状态枚举
    getStatuses() {
        return {
            [STATUS_NOSTATE]: '否',
            [STATUS_RTURNVISIT]: '是',
        }

    },

    //得到职务枚举
    getJobs() {
        return {
            [JOB_RECTOR]: '校长',
            [JOB_DIRECTOR]: '主任',
            [JOB_TEACHER]: '教师',
            [JOB_OTHER]: '其他'
        }
    },

    // 创建联系人
    create(contact) {
        return http.post('/api/contacts/create', contact)
    },

    // 检测是否存在关键联系人
    check_contact(customer_id) {
        return http.get('/api/common/get-contacts', {
            params: {
                customer_id: customer_id,
                status: 1
            }
        });
    },

    //更新联系人信息
    update(contact) {
        return http.put('/api/contacts/update?id=' + contact.id, contact);
    },

    //删除联系人信息
    delete(id) {
        return http.delete('/api/contacts/delete', {
            params: {
                id: id
            }
        }); 
    },    

    // 得到联系人列表
    getList(params) {
        return http.get('/api/contacts/index', {
            params: params
        });
    },

	// 得到我的联系人列表
	getMyList(params) {
		return http.get('/api/contacts/my-index', {
			params: params
		});
	},

    //得到单个联系人信息
    getInfo(contactId) {
        return http.get('/api/contacts/view', {
            params: {
                id: contactId
            }
        })
    },

    //得到公共接口单个联系人信息，
    getCommonInfo(contactId)
    {
	    return http.get('/api/common/get-contact-view', {
		    params: {
			    id: contactId
		    }
	    })
    },

    viewMobile(customer_id, contact_id) {
        return http.get('/api/contacts/view-mobile', {
            params: {
                customer_id: customer_id,
                contact_id: contact_id
            }
        })
    },

    //更新联系人信息
    changeLeadStatus(contact) {
        return http.put('/api/contacts/change-lead-status?id=' + contact.id, contact);
    },


    //解密手机号
    decodeMobile(params) {
        return http.get('/api/contacts/decode-mobile', {
            params : params
        });
    },
     // 协作人导入
        importContact(formData) {
            return http.post('/api/contacts/import-contacts', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
        }
}


// WEBPACK FOOTER //
// ./src/services/contact.js